import React from 'react';
import { HEALTH_STATES, statusColors } from '@/const';
import { FormattedText } from '@/components/uiKit/FormattedText';

interface HealthStatusIndicatorProps extends React.HTMLAttributes<HTMLDivElement> {
  type: string;
  showDescription?: boolean;
  color?: string;
}

export const HealthStatusIndicator = ({
  type,
  color,
  showDescription = false,
  className,
  ...rest
}: HealthStatusIndicatorProps) => {
  const state = HEALTH_STATES[type];
  const statusColor = color || statusColors[type];

  return (
    <div className={className} {...rest}>
      <div className="flex items-center gap-1.5">
        <div className="text-xs font-semibold capitalize" style={{ color: statusColor }}>
          <FormattedText label={state.title} />
        </div>
      </div>

      {showDescription ? (
        <div className="text-sm pt-1">
          <FormattedText label={state.description} />
        </div>
      ) : null}
    </div>
  );
};
